import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { titleize, dig } from 'spiceutils';
import { Select } from 'spicecomponents';

import { setPresetClusterControl } from '../../../../containers/App/actions';
import { makeSelectPresetList, makeSelectPresetListName } from '../../../../containers/App/selectors';

class PresetList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: dig(props.presetCountryLists, [0, 'name']) || 'None',
    };
  }
  componentWillReceiveProps(newProps) {
    if (newProps.presetListName !== this.state.value) {
      this.setState({ value: newProps.presetListName || 'None' });
    }
  }
  onChange(value) {
    let list = [];
    if (value !== 'None') {
      list = this.props.presetCountryLists.filter((l) =>
        l.name === value
      )[0].countryList;
    }

    this.props.setPresetClusterControl(value, list);
  }
  getOptions() {
    return [{ value: 'None' }].concat(
      this.props.presetCountryLists.map((list) => ({
        text: titleize(list.name),
        value: list.name,
      }))
    );
  }
  render() {
    const options = this.getOptions();
    if (options.length > 1) {
      return (
        <div>
          <label htmlFor="presetCountryList">Choose one of our preset lists</label>
          <Select name="presetCountryList" options={options} onChange={(e) => this.onChange(e)} value={this.state.value} />
        </div>
      );
    }
    return null;
  }
}

PresetList.propTypes = {
  presetCountryLists: PropTypes.array,
  setPresetClusterControl: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  presetCountryLists: makeSelectPresetList('CountryList'),
  presetListName: makeSelectPresetListName('CountryList'),
});

export function mapDispatchToProps(dispatch) {
  return {
    setPresetClusterControl: (name, list) => {
      dispatch(setPresetClusterControl('CountryList', name, list));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
)(PresetList);



// WEBPACK FOOTER //
// ./app/components/FormControls/CountryList/PresetList/index.js